// utils/statusUtils.js
import React from 'react';
import classNames from 'classnames';
import Badge from 'react-bootstrap/Badge'; // Make sure to import Badge if you're using it from a UI library

export const formatValue = (current) => {
    return Number.isInteger(current) ? current : current?.toFixed(2) || 'N/A';
};

export const renderStatus = (status, value) => (
    <span className={classNames(getStatusClass(status), 'fw-semibold')}>
        {Number.isInteger(value) ? value : value?.toFixed(2) || 'N/A'}
    </span>
);

export const renderBadge = (status) => {
    let badgeClass = '';
    let badgeLabel = '';

    switch (status) {
        case 'ON':
            badgeClass = 'badge-success-lighten';
            badgeLabel = 'ON';
            break;
        case 'OFF':
            badgeClass = 'badge-danger-lighten';
            badgeLabel = 'OFF';
            break;
        case 'Reverse':
            badgeClass = 'badge-danger-lighten';
            badgeLabel = 'REVERSE';
            break;
        case 'Forward':
            badgeClass = 'badge-success-lighten';
            badgeLabel = 'FORWARD';
            break;
        case 'GREEN':
            badgeClass = 'badge-success-lighten';
            badgeLabel = 'GREEN';
            break;
        case 'RED':
            badgeClass = 'badge-danger-lighten';
            badgeLabel = 'RED';
            break;
        case 'YELLOW':
            badgeClass = 'badge-yellow-lighten';
            badgeLabel = 'YELLOW';
            break;
        case 'OTHER':
            badgeClass = 'badge-yellow-lighten';
            badgeLabel = 'OTHER';
            break;
        default:
            badgeClass = 'badge-secondary-lighten';
            badgeLabel = status;
            break;
    }

    return (
        <Badge bg="" className={classNames('me-1', badgeClass)}>
            {badgeLabel}
        </Badge>
    );
};

export const renderBadgeIPS = (statusValue) => {
    return (
        <Badge
            bg=""
            className={classNames(
                'me-1',
                statusValue === 'UNHEALTHY' ? 'badge-danger-lighten' : 'badge-success-lighten'
            )}>
            {statusValue}
        </Badge>
    );
};

export const getSeverityClass = (severity) => {
    switch (severity) {
        case 1:
            return 'text-success';
        case 2:
            return 'text-warning';
        case 3:
            return 'text-danger';
        default:
            return '';
    }
};

export const getStatusClass = (status) => {
    switch (status) {
        case 1:
            return 'text-success';
        case 2:
            return 'text-warning';
        case 3:
            return 'text-danger';
        default:
            return '';
    }
};

export const getRibbonColor = (severity) => {
    switch (severity) {
        case 1:
            return 'success';
        case 2:
            return 'warning';
        case 3:
            return 'danger';
        default:
            return '';
    }
};

export const getRibbonStatus = (severity) => {
    switch (severity) {
        case 1:
            return 'Normal';
        case 2:
            return 'Warning';
        case 3:
            return 'Alert';
        default:
            return '';
    }
};

export const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');
